var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WidgetCard',{attrs:{"title":"Upcoming website crawls","icon":"clock-circle","loading":_vm.loading,"error":_vm.error,"empty":_vm.emptyMessage}},[(_vm.rows.length)?_c('CrawlScheduleList',{attrs:{"rows":_vm.rows}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }